module.exports = __webpack_public_path__ + "img/helpme.df9c6d44.png";